// ##########################################################################################
// Gallery Append Manager
// ==========================================================================================
// The Append Manager object, defined by the return value of the function below, is a
// submodule of the JDA gallery module. This submodule is responsible for adding entry
// blocks (each of these being a piece of HTML that represents an award entry) to the
// mod-gallery-main div of the gallery module. Whenever it does this, it takes entry data
// from the Data Manager module (which may have been loaded asynchronously.
// Entry blocks remain hidden, until they are 'animated in' by the Reveal Manager.
// ##########################################################################################

var galleryModule = app.mediator.getModule(MODULE_NAME__GALLERY);
galleryModule.injectSubModule('appendManager', function() {

	// =======================================================================
	// Module data
	// =======================================================================

    var numberOfItemsPerLoad = 30;

	// =======================================================================
	// Module methods
	// =======================================================================

    function getNumberOfItemsPerLoad() {
        return numberOfItemsPerLoad;
    }

    function getTargetElement() {
        return galleryModule.getRootElem().find('.mod-gallery-main');
    }

    function appendItem(itemData) {

        if ($('.featured-block[data-entry-id=' + itemData.id + ']').length) {
            
            // This should never be the case. If you see this message, something is wrong:
            // The project item has not been correctly removed before being added again.
            console.warn('An entry with the id of ' + itemData.id + ' (' + itemData.name + ') already exists in the DOM, so it will not be appended.');
            return;
        }

        var scope = this;
        var entryBlockManager = galleryModule.getSubModule('entryBlockManager');

        // Get the item HTML, and then add the HTML to the items wrapper div
        var $targetElement = getTargetElement();
        var itemHtml = entryBlockManager.getBlockHtml(itemData).html();
        $targetElement.append(itemHtml);
        var entryBlockSelector = galleryModule.getSelectorClass('entryBlock');
        var $newlyAddedBlock = $targetElement.find('.' + entryBlockSelector + ':last-child');

        // Initialise the new item
        // This function call tends to cause IE to hang.
        // By putting it into a timeout, we execute it asynchronously, preventing
        // this script from blocking the main thread, and fixing the IE hang. We can get away with doing this,
        // as the we do not require block initialisation code to run immediately.
        setTimeout(function() {
            entryBlockManager.initialiseBlock($newlyAddedBlock);
        }, 10);
    }

    function appendXItems(numberToAppend) {
        var entriesData = galleryModule.getSubModule('dataManager').getEntriesData();
        var startIndex = getNumberOfItemsInTheDom();
        var endIndex = startIndex + numberToAppend;
        var entriesToAppend = entriesData.slice(startIndex, endIndex);
        entriesToAppend.forEach(function (entryData) {
            appendItem(entryData);
        });
    }

    function appendMoreItems() {
        appendXItems(numberOfItemsPerLoad);
    }

	function removeAll() {
        var $targetElement = getTargetElement();
        $targetElement.html('');
	}

    function getNumberOfItemsInTheDom() {
        var blockSelector = galleryModule.getSelectorClass('entryBlock');
        return galleryModule.getRootElem().find('.' + blockSelector).length;        
    }

	// =======================================================================
	// Public API
	// =======================================================================

	return {
        appendXItems: appendXItems,
        appendMoreItems: appendMoreItems,
        removeAll: removeAll,
        getNumberOfItemsPerLoad: getNumberOfItemsPerLoad,
        getNumberOfItemsInTheDom: getNumberOfItemsInTheDom
	}; 
});